<template>
  <div>
    <!-- :close-on-click-modal='false'  是否可以通过点击 modal 关闭 Dialog   -->
    <el-dialog
      :visible.sync="data.visible"
      :modal-append-to-body="false" 
      :width="data.size + 'px'"
      :title="data.title"
      :close="fun"
      :before-close="fun"
    >
      <slot></slot>
      <!-- 内容 -->
      <slot name="content"></slot>
      <!-- 操作按钮 -->
      <div slot="footer">
        <slot name="btns"></slot>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["handleClose", "dialog"],
  data() {
    return {
      data: {
        title: "",
        size: 720,
        visible: false,
      },
      fun: function () {},
    };
  },
  watch: {
    dialog: {
      handler(val) {
        this.$set(this, "data", val);
      },
      immediate: true,
    },
    handleClose: {
      handler(val) {
        this.$set(this, "fun", val);
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
::v-deep .dialogs-box .el-dialog__body {
  border-top: 2px solid #f2f2f2;
}
el-dialog{
  width: 80% !important;
}
</style>